export default "__VITE_ASSET__Cl$_5pCp__"